import React, { Component } from 'react';
import Raven from 'raven-js';

class ErrorBoundary extends Component<any, { error: any }> {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });

    if (process.env.NODE_ENV !== 'development') {
      Raven.captureException(error, { extra: errorInfo });
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ height: 40 }}>
          <p>
            We're sorry — something's gone wrong. Our team has been notified.
          </p>
        </div>
      );
    } else {
      return this.props.children;
    }
  }
}

export default ErrorBoundary;
